"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var swiftPackagePlugin_exports = {};
__export(swiftPackagePlugin_exports, {
  swiftPackagePlugin: () => swiftPackagePlugin
});
module.exports = __toCommonJS(swiftPackagePlugin_exports);
var import_swiftPackageModule = require("./swiftPackageModule");
function swiftPackagePlugin(platform, root) {
  return {
    name: "one:swift-package",
    load: {
      filter: {
        id: /\.swift$/
      },
      handler(id) {
        var { code, watchFiles } = (0, import_swiftPackageModule.renderSwiftPackageModule)(id, platform, root);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
        try {
          for (var _iterator = watchFiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var file = _step.value;
            this.addWatchFile(file);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        return code;
      }
    }
  };
}
//# sourceMappingURL=swiftPackagePlugin.js.map
